import { useDispatch } from 'react-redux';

import { closeForm, showForm } from './macBotSlice';

function useMacBotActions(targetBlockToAddToId: string | null) {
  const dispatch = useDispatch();

  const setShow = (key: Parameters<typeof showForm>[0]['key'], data: any = null, parentId: string | null = targetBlockToAddToId) => {
    dispatch(
      showForm({
        key,
        payload: { data, parentId },
      })
    );
  };

  return {
    setShowResponse: (data?: any) => setShow('isShowResponseForm', data, data?.id),
    setShowUserInput: (data?: any) => setShow('isShowUserInputForm', data, data?.id),
    setShowGoto: (data?: any) => setShow('isShowGotoForm', data, data?.id),
    setShowSpeechRecording: (data?: any) => setShow('isShowSpeechRecording', data, data?.id),
    setShowElse: (data?: any) => setShow('isShowElseForm', data, data?.id),
    setShowButton: (data?: any) => setShow('isShowButtonForm', data, data?.id),
    setShowJSCode: (data?: any) => setShow('isShowJSCode', data, data?.id),
    setShowLink: (data?: any) => setShow('isShowLinkForm', data, data?.id),
    setShowVariable: (data?: any) => setShow('isShowVariableForm', data, data?.id),
    setShowHTTPRequest: (data?: any) => setShow('isShowHTTPRequestForm', data, data?.id),
    setShowReceiveAttachment: (data?: any) => setShow('isShowReceiveAttachmentForm', data, data?.id),
    setShowMakeWebHook: (data?: any) => setShow('isShowMakeWebHookForm', data, data?.id),
    setShowPassToAI: (data?: any) => setShow('isShowPassToAi', data, data?.id),
    setShowCondition: (data?: any) => setShow('isShowConditionForm', data, data?.id),
    setShowOverrideVariable: (data?: any) => setShow('isShowOverrideVariableForm', data, data?.id),
    setShowSummarizeConversation: (data?: any) => setShow('isShowSummarizeConversation', data, data?.id),
    setShowCreateVariable: (data?: any) => setShow('isShowCreateVariableForm', data, data?.id),
    setShowLead: (data?: any) => setShow('isShowLeadForm', data, data?.id),
    setShowMedia: (data?: any) => setShow('isShowMediaForm', data, data?.id),
    setShowNotifyMeByEmail: (data?: any) => setShow('isShowNotifyMeByEmailForm', data, data?.id),
    setShowAttachment: (data?: any) => setShow('isShowAttachmentForm', data, data?.id),
    setShowDelay: (data?: any) => setShow('isShowDelayForm', data, data?.id),
    setShowEndConversation: (data?: any) => setShow('isShowEndOfConversationForm', data, data?.id),
    setShowSuperUserManagerServices: (data?: any) => setShow('isShowSuperUserManagerServices', data, data?.id),
    setShowCheckIfUserExists: (data?: any) => setShow('isShowCheckIfUserExists', data, data?.id),
    setShowUserCredential: (data?: any) => setShow('isShowUserCredential', data, data?.id),
    setShowGetUserInfo: (data?: any) => setShow('isShowGetUserInfo', data, data?.id),
    setShowRegisterUser: (data?: any) => setShow('isShowRegisterUser', data, data?.id),
    setShowSwitchToChatbot: (data?: any) => setShow('isShowSwitchToChatbot', data, data?.id),
    setShowAskToAI: (data?: any) => setShow('isShowAskToAI', data, data?.id),
    setShowMessages: (data: any) => setShow('isShowMessages', data),

    closeForm: (parentId?: any) => dispatch(closeForm({ parentId: parentId })),
  };
}

export default useMacBotActions;
